import Dict from '@/utils/dict-utils'

// 用于报名审核的alias字段
import { auditStatusDict } from '@/dictionary/project/common'

// 招标(无审判)
export const bidInviteBidStatusDict = new Dict({
  UNPUBLISHED: {
    label: '未发布',
    value: 1,
    type: 'warning',
    permission: ['edit', 'del'],
    routerName: 'BiddingForm'
  },
  PUBLISHED: {
    label: '已发布',
    value: 2,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'BiddingInfo'
  },
  REGISTERING: {
    label: '报名中',
    value: 3,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'BiddingApply'
  },
  REGISTER_CLOSED: {
    label: '报名已截止',
    value: 4,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'BiddingApply'
  },
  CANDIDATE_PUBLISHED: {
    label: '已公示',
    value: 5,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'BiddingWinner'
  },
  FINISHED: {
    label: '已完结',
    value: 6,
    type: 'success',
    permission: ['look', 'copy'],
    routerName: 'BiddingWinnerDetail'
  },
  CLOSED: {
    label: '已终止招标',
    value: 7,
    type: 'info',
    permission: ['look', 'copy'],
    routerName: 'BiddingInfo'
  },
  RESTART: {
    label: '已重新招标',
    value: 8,
    type: 'info',
    permission: ['look', 'copy'],
    routerName: 'BiddingInfo'
  },
  DOING: {
    label: '进行中',
    value: 99,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'BiddingInfo'
  }
})

// 招标(有审判)
export const bidFlowStatusDict = new Dict({
  ...bidInviteBidStatusDict.object,
  PUBLISHING: {
    value: 10,
    type: 'info',
    label: '发布中',
    permission: ['look', 'copy'],
    routerName: 'BiddingInfo'
  },
  PUBLISH_ING: {
    value: 11,
    label: '发布审批中',
    permission: ['look', 'copy'],
    routerName: 'BiddingInfo'
  },
  PUBLISH_PASS: {
    value: 12,
    label: '发布审批通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingApply'
  },
  PUBLISH_REJECT: {
    value: 13,
    label: '发布审批不通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingInfo'
  },
  CHANGE_TO_DO: {
    value: 20,
    label: '待提交变更审批',
    permission: ['look', 'copy'],
    routerName: 'BiddingChangeNewestDetail'
  },
  CHANGE_ING: {
    value: 21,
    label: '变更审批中',
    permission: ['look', 'copy'],
    routerName: 'BiddingChangeNewestDetail'
  },
  CHANGE_PASS: {
    value: 22,
    label: '变更审批通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingApply'
  },
  CHANGE_REJECT: {
    value: 23,
    label: '变更审批不通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingChangeNewestDetail'
  },
  CANDIDATE_TO_DO: {
    value: 30,
    label: '待提交候选公示审批',
    permission: ['look', 'copy'],
    routerName: 'BiddingCandidateNewest'
  },
  CANDIDATE_ING: {
    value: 31,
    label: '候选公示审批中',
    permission: ['look', 'copy'],
    routerName: 'BiddingCandidateNewest'
  },
  CANDIDATE_PASS: {
    value: 32,
    label: '确定候选审批通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingCandidateDetail'
  },
  CANDIDATE_REJECT: {
    value: 33,
    label: '确定候选审批不通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingCandidateNewest'
  },
  WINNER_TO_DO: {
    value: 40,
    label: '待提交成交审批',
    permission: ['look', 'copy'],
    routerName: 'BiddingResultNewest'
  },
  WINNER_ING: {
    value: 41,
    label: '确定成交审批中',
    permission: ['look', 'copy'],
    routerName: 'BiddingResultNewest'
  },
  WINNER_PASS: {
    value: 42,
    label: '确定成交审批通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingWinnerDetail'
  },
  WINNER_REJECT: {
    value: 43,
    label: '确定成交审批不通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingResultNewest'
  },
  AUCTION_TO_DO: {
    value: 50,
    label: '待提交流标审批',
    permission: ['look', 'copy'],
    routerName: 'BiddingAuctionNewest'
  },
  AUCTION_ING: {
    value: 51,
    label: '流标审批中',
    permission: ['look', 'copy'],
    routerName: 'BiddingAuctionNewest'
  },
  AUCTION_PASS: {
    value: 52,
    label: '流标审批通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingAuctionNewest'
  },
  AUCTION_REJECT: {
    value: 53,
    label: '流标审批不通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingAuctionNewest'
  },
  CLARIFICATION_TO_DO: {
    value: 60,
    label: '待提交澄清审批',
    permission: ['look', 'copy'],
    routerName: 'BiddingNewestFileChanges'
  },
  CLARIFICATION_ING: {
    value: 61,
    label: '澄清审批中',
    permission: ['look', 'copy'],
    routerName: 'BiddingNewestFileChanges'
  },
  CLARIFICATION_PASS: {
    value: 62,
    label: '澄清审批通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingApply'
  },
  CLARIFICATION_REJECT: {
    value: 63,
    label: '澄清审批不通过',
    permission: ['look', 'copy'],
    routerName: 'BiddingNewestFileChanges'
  }
})

// 招标方式字典
export const bidInviteWayDict = new Dict({
  PUBLIC_BIDDING: { label: '公开招标', value: 1 },
  INVITE_BIDDING: { label: '邀请招标', value: 2 },
  COMPETITIVE_CONSULT: { label: '竞争性磋商', value: 3 },
  COMPETITIVE_NEGOTIATION: { label: '竞争性谈判', value: 4 },
  INQUIRY: { label: '询价', value: 5 },
  SINGLE_SOURCE: { label: '单一来源', value: 6 }
})
// 备案--招标方式字典
export const efficientBidInviteWayDict = new Dict({
  ...bidInviteWayDict.keyMap,
  NEGOTIATION: { label: '谈判采购', value: 9 }
})

// 备案--招标方式字典展示
export const efficientBidInviteWayShowDict = new Dict({
  ...efficientBidInviteWayDict.keyMap,
  DIRECT: { label: '询比采购', value: 7 },
  COMPETE: { label: '竞价采购', value: 8 },
  OTHER: { label: '其他招标', value: 10 }
})

// 发布方式字典
export const bidPublishWayDict = new Dict({
  NOTICE_BIDDING: { label: '招标公告', value: 1 },
  INVITE_BIDDING: { label: '邀请函', value: 2 }
})

// 中标方式数据字典
export const bidWinWayDict = new Dict({
  SINGLE: { label: '单个中标', value: 1 },
  SHORTLIST: { label: '入围', value: 2 }
})

// 报名审核状态数据字典
export const bidApplyReviewStatusDict = new Dict({
  UN_AUDIT: {
    label: '待审核',
    value: 0,
    type: 'info',
    permission: ['review', 'look'],
    alias: auditStatusDict.PENDING.alias
  },
  PASS_AUDIT: {
    label: '审核通过',
    value: 1,
    type: 'success',
    permission: ['look'],
    alias: auditStatusDict.PASSED.alias
  },
  FAIL_PASS_AUDIT: {
    label: '审核不通过',
    value: 2,
    type: 'danger',
    permission: ['look'],
    alias: auditStatusDict.NOT_PASSED.alias
  },
  TIME_OUT_NOT_ACCEPTED: {
    label: '超时未审核',
    value: 9,
    type: 'danger',
    permission: ['look'],
    alias: auditStatusDict.TIME_OUT.alias
  }
})

// 供应商报名是否审核
export const bidRegisterAuditFlagDict = new Dict({
  NO: { value: 0, label: '否' },
  YES: { value: 1, label: '是' }
})

// 代理委托状态字典
export const bidAcceptStatusDict = new Dict({
  EDITING: {
    value: 0,
    label: '编辑中',
    type: 'info',
    permission: ['edit', 'del']
  },
  WAIT_ACCEPT: {
    value: 1,
    label: '待接受',
    type: 'info',
    permission: ['accept', 'refuse', 'look']
  },
  ACCEPTED: {
    value: 2,
    label: '已接受',
    titleLabel: '接受',
    type: 'success',
    permission: ['publish', 'look']
  },
  REFUSED: {
    value: 3,
    label: '已拒绝',
    titleLabel: '拒绝',
    type: 'danger',
    permission: ['look']
  }
})

// 委托状态字典
export const bidEntrustStatusDict = new Dict({
  EDITING: {
    value: 0,
    label: '编辑中',
    type: 'info',
    permission: ['edit', 'del']
  },
  WAIT_ACCEPT: {
    value: 1,
    label: '待接受',
    type: 'warning',
    permission: ['look']
  },
  ACCEPTED: {
    value: 2,
    label: '已接受',
    type: 'success',
    titleLabel: '接受',
    permission: ['look']
  },
  REFUSED: {
    value: 3,
    label: '已拒绝',
    titleLabel: '拒绝',
    type: 'danger',
    permission: ['del', 'look']
  },
  DOING: {
    value: 99,
    label: '进行中',
    type: 'primary',
    permission: ['look']
  }
})

// 是否发布中标结果公告
export const bidWhetherPublishResultDict = new Dict({
  YES: { value: 1, label: '是' },
  NO: { value: 2, label: '否' }
})

// 澄清状态
export const supplementStatusDict = new Dict({
  AUDIT: { value: 1, label: '澄清中' },
  SUCCESS: { value: 2, label: '澄清成功' },
  FAIL: { value: 3, label: '澄清失败' }
})

// 是否发布候选人结果公示
export const bidWhetherPublishCandidateDict = new Dict({
  YES: { value: 1, label: '是' },
  NO: { value: 2, label: '否' }
})

// 审核供应商
export const bidAuditSupplierResultDict = new Dict({
  PASS: { label: '通过', value: 1 },
  FAIL: { label: '不通过', value: 2 }
})

// 项目补录状态
export const bidSupplementStatusDict = new Dict({
  UN_PUBLISH: { label: '未发布', value: 0 },
  DELETE: { label: '已删除', value: -1 },
  EDITING: { label: '编辑中', value: 1 },
  RECORD: { label: '结果备案', value: 2 },
  UN_RECORD: { label: '项目登记', value: 3 }
})

// 项目补录类型
export const bidSupplementTypeDict = new Dict({
  REGISTER: { label: '项目登记', value: 3 },
  RECORD: { label: '结果备案', value: 2 }
})

// 登记原因
export const bidSupplementRegisterReasonDict = new Dict({
  ENTRY_TRADING_ITEM: { label: '进场交易项目', value: 1 },
  CLASSIFIED_ITEM: { label: '涉密项目', value: 2 },
  OTHER_ITEM: { label: '其他项目', value: 3 }
})

// 是否对外发布登记公告
export const bidSupplementRegisterPublishDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 是否对外发布备案公告
export const bidSupplementRecordPublishDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 是否发布流标公告
export const bidPublishAuctionDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})

// 流标状态
export const bidAuctionStatusDict = new Dict({
  RESTART: { label: '重新招标', value: 2 },
  STOP: { label: '终止招标', value: 1 }
})

// 是否免收标书费
export const bidChargeStatusDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})

// 免收标书费范围
export const bookFeeFreeRangeDict = new Dict({
  ALL: { label: '全部', value: 1 },
  SOME: { label: '部分', value: 2 }
})

// 整合的免收字典
export const bookFeeSendDict = new Dict({
  ALL_FREE: {
    label: '全部免收',
    value: 1,
    alias: `${bidChargeStatusDict.YES.value}-${bookFeeFreeRangeDict.ALL.value}`
  },
  SOME_FREE: {
    label: '部分免收',
    value: 3,
    alias: `${bidChargeStatusDict.YES.value}-${bookFeeFreeRangeDict.SOME.value}`
  },
  NO_FREE: {
    label: '不免收',
    value: 2,
    alias: `${bidChargeStatusDict.NO.value}-`
  }
})

// 组织方式
export const bidOrganizationModeDict = new Dict({
  ENTRUST: { label: '委托招标', value: 1 },
  AUTONOMY: { label: '自主招标', value: 0 }
})

// 组织方式
export const supplementOrganizationModeDict = new Dict({
  ENTRUST: { label: '委托招标', value: 1 },
  AUTONOMY: { label: '自主招标', value: 2 }
})

// 邀请供应商类型
export const bidInviteTypeDict = new Dict({
  NORMAL: { label: '正常流程添加', value: 0 },
  ADD: { label: '追加供应商', value: 1 }
})

// 上传招标文件方式
export const uploadBiddingFileTypeDict = new Dict({
  YES: { label: '现在上传', value: 0 },
  NO: { label: '稍后上传', value: 1 }
})

// 补发文件类型
export const reissueUploadFileTypeDict = new Dict({
  BEFORE_OPEN: { label: '开标前上传', value: 1 },
  After_OPEN: { label: '开标后上传', value: 2 },
  NO_UPLOAD: { label: '还未上传', value: 0 },
  NO_SUPPLEMENT: { label: '非补发文件', value: -1 }
})

// 是否允许联合体报名
export const isComboDict = new Dict({
  YES: { label: '允许', value: 1 },
  NO: { label: '不允许', value: 0 }
})

// 公示状态
export const candidateStatusDict = new Dict({
  CLOSED: { label: '已关闭', value: -1 },
  INIT: { label: '初始化', value: 0 },
  EDIT: { label: '编辑', value: 2 },
  PUBLISHED: { label: '已发布', value: 3 }
})

// 公告状态
export const winnerStatusDict = new Dict({
  CLOSED: { label: '已关闭', value: -1 },
  INIT: { label: '初始化', value: 0 },
  EDIT: { label: '编辑', value: 2 },
  PUBLISHED: { label: '已发布', value: 3 }
})

// 中标通知书发布方式
export const winnerInformTypeDict = new Dict({
  PLATFORM: { label: '自定义通知书', value: 0 },
  ONLINE: { label: '线上上传', value: 1 },
  OFFLINE: { label: '线下邮寄', value: 2 }
})

// 是否收取保证金
export const needBidBondDict = new Dict({
  YES: { label: '收取', value: 1 },
  NO: { label: '不收取', value: 0 }
})

// 保证金收取方式
export const bondBidTypeDict = new Dict({
  PLATFORM: { label: '平台代收', value: 0 },
  SELF: { label: '自主收取', value: 1 }
})

// 保证金缴纳状态
export const bondBidPayDict = new Dict({
  YES: { label: '已缴纳', value: 3 },
  NO: { label: '未缴纳', value: 1 }
})

// 保证金缴纳状态查询筛选
export const bondBidPaySearchDict = new Dict({
  YES: { label: '已缴纳', value: 1 },
  NO: { label: '未缴纳', value: 0 }
})

// 保证金信息维护方
export const thirdPushGuaranteeDict = new Dict({
  PLATFORM: { label: '云采购', value: 1 },
  INTERFACE: { label: '第三方通过接口维护', value: 2 },
  MANUAL: { label: '第三方手动维护', value: 3 }
})

// 是否已同意退款
export const bondBidRefundStatusDict = new Dict({
  YES: { label: '同意', value: 1 },
  NO: { label: '不同意', value: 0 }
})

// 是否候选
export const isBidCandidateRefundDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 招标保证金缴纳状态（转账汇款）
export const depositBidStatusDict = new Dict({
  NOT_STARTED: { value: 0, label: '未缴纳', type: 'primary' },
  PENDING: { value: 1, label: '未缴纳', type: 'primary' },
  PAYMENT: { value: 2, label: '未缴纳', type: 'primary' },
  SUCCESS: { value: 3, label: '已缴纳', type: 'success' },
  OUT_TIME: { value: 4, label: '未缴纳', type: 'danger' },
  REFUND_LETTER: { value: 5, label: '未缴纳', type: 'primary' },
  FAIL: { value: 9, label: '未缴纳', type: 'primary' }
})

// 保证金退回状态
export const depositBidBackStatusDict = new Dict({
  PENDING: { value: 1, label: '待申请', type: 'warning' },
  APPLIED: { value: 2, label: '退款中', type: 'primary' },
  RETURNED: { value: 3, label: '已退款', type: 'success' },
  DELAY_RETURN: {
    value: 9,
    label: '退款中',
    type: 'warning'
  },
  RETURN_IMMEDIATE: {
    value: 11,
    label: '退款中',
    type: 'warning'
  },
  RETURN_WAIT: {
    value: 12,
    label: '退款中',
    type: 'warning'
  }
})

// 标书文件展示状态
export const bookFeeNodeStatusDict = new Dict({
  NOT_STARTED: { value: 0, label: '参与后缴纳标书费才可以查看' },
  NO_BID_FILE: { value: 1, label: '未上传招标文件，请咨询招标单位' },
  BID_FILE: { value: 2, label: '招标标书费支付和下载组件' },
  OUT_TIME: { value: 3, label: '已过报名截止时间，不能缴纳标书费' }
})

// ----------------------------
// （供应商）供应商候选状态
export const bidCandidateStatusDict = new Dict({
  INIT: { value: 0, label: '未确定', tipLabel: '-' },
  WIN: { value: 2, label: '候选', tipLabel: '是' },
  LOSE: { value: 3, label: '未候选', tipLabel: '否' }
})

// （供应商）供应商中标结果
export const bidSupplierResultDict = new Dict({
  WIN: {
    label: '已中标！', // 平台生成中标文件
    tip: '已成功中标',
    icon: 'success',
    offlineLabel: '中标通知书已线下邮寄', // 线下邮寄
    value: 2,
    type: 'success'
  },
  LOSE: {
    label: '已完结！',
    tip: '未中标',
    icon: 'error',
    offlineLabel: '很遗憾！你未中标！',
    value: 3,
    type: 'danger'
  }
})

// （供应商）供应商报名进度状态
export const bidSupplierStatusDict = new Dict({
  SING_UP: {
    label: '信息核验',
    value: 1
  },
  DOWNLOAD_FILE: {
    label: '下载招标文件',
    value: 2
  },
  CANDIDATE: {
    label: '查看候选人公示',
    value: 3
  },
  RESULT: {
    label: '查看结果通知书',
    value: 4
  }
})
// 文件类型
export const fileTypeDict = new Dict({
  BID: { label: '招标文件', value: 1 },
  OTHER: { label: '图纸文件', value: 2 },
  CLARIFY: { label: '澄清文件', value: 3 },
  KPB_BID: { label: '电子招标文件', value: 11 }
})

// 文件预览状态
export const previewFileStatusDict = new Dict({
  UN_PREVIEW: { label: '未查阅', value: 0 },
  PART_PREVIEW: { label: '部分查阅', value: 1 },
  ALL_PREVIEW: { label: '全部查阅', value: 2 }
})

// 投标文件状态
export const bidSubmitStatusDict = new Dict({
  INIT: { label: '未提交', value: 0, type: 'info' },
  TO_UPLOAD: { label: '未提交', value: 1, type: 'info' },
  UPLOAD: { label: '已提交', value: 2, type: 'primary' },
  WITHDRAW: { label: '未提交', value: 3, type: 'info' }
})

// 代理服务费收费标准
export const agencyServiceChargeStandardDict = new Dict({
  COUNTRY_STANDARD: { label: '按国家收费标准', value: 1, unit: '%' },
  FIXED_STANDARD: { label: '按固定价收取', value: 2, unit: '元' },
  PERCENT_STANDARD: { label: '按中标金额的百分比收取', value: 3, unit: '%' },
  OTHER_STANDARD: { label: '其他收费', value: 4, unit: '' }
})

// 标书费支付状态查询筛选
export const isBookFeePaySearchDict = new Dict({
  YES: { label: '支付成功', value: 1 },
  NO: { label: '未支付', value: 0 }
})
